import { useParams } from "react-router-dom";

/**
 * The two ids the tracker table works with. They are different kinds: the tracker's id keys the
 * tracker's own reads (its settings, its columns), the list's id keys the list-scoped endpoints
 * (`/tracker-organization/:id`, the deep-research bulk run). A host passes either explicitly; on the
 * tracker page both fall back to the URL's `:id`. Never hand one where the other belongs: they are
 * different numbers, and the server reads whichever row carries it (PREC-4660).
 */
export const useTrackerTableIds = (
	trackerIdProp?: number,
	listIdProp?: number
): { trackerId?: number; listId?: number } => {
	const { id: urlId } = useParams();
	const urlNumber = urlId ? +urlId : undefined;

	return { trackerId: trackerIdProp ?? urlNumber, listId: listIdProp ?? urlNumber };
};
